// extracted by mini-css-extract-plugin
export default {"wrapper":"mfvHw","wrapper__icon":"yFL4N","wrapper__icon--size":"cVtGI","wrapper__title":"ctOus"};